import { render, staticRenderFns } from "./FertilizerDetailForm.vue?vue&type=template&id=32b359b7&scoped=true&"
import script from "./FertilizerDetailForm.vue?vue&type=script&lang=js&"
export * from "./FertilizerDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./FertilizerDetailForm.vue?vue&type=style&index=0&id=32b359b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b359b7",
  null
  
)

export default component.exports